import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/http/auth.service';

@Component({
  // Added by fix-standalone-components script
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(public authService: AuthService) { }

  ngOnInit(): void {
  }


}
